/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { LoadingOverlay, Center, Text, Pagination, Stack, Box, Divider } from '@mantine/core';
import { useContext } from 'react';
import { useElementSize } from '@mantine/hooks';
import PanePaper from '../../Molecules/PanePaper';
import { ContactsContext } from '../../Service/Context/ContactsContext';
import BookitupTable from '../../Atoms/BookitupTable';
import { ThemeText } from '../../Atoms/ThemeText';
import { WindowContext } from '../../Service/Context/WindowContext';
import ContactRow from './ContactRow';

const ContactsTable = () => {
  const PAGE_SIZE = 30;
  const { ref, width } = useElementSize();
  const { xs } = useContext(WindowContext);
  const { filter, totalPages, count, loading, contacts, updateFilter } = useContext(ContactsContext);
  const { pageNumber } = filter;

  const showColumns = {
    showMail: width > 500,
    showPhone: width > 600,
    showGroups: width > 700,
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      {!loading && contacts && contacts.length === 0 && <EmptyList />}
      {contacts && contacts.length > 0 && (
        <PanePaper borderlessVersion title={xs ? 'Kontakte' : undefined} withoutBorder>
          <BookitupTable>
            <thead>
              <tr>
                <th>Name</th>
                {showColumns.showMail && <th>E-Mail</th>}
                {showColumns.showPhone && <th>Telefonnummer</th>}
                {showColumns.showGroups && <th>Gruppen</th>}
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <ContactRow key={contact.id} contact={contact} {...showColumns} />
              ))}
            </tbody>
          </BookitupTable>
        </PanePaper>
      )}
      <Center mt="xl" mb="sm">
        <Pagination
          noWrap
          siblings={1}
          total={totalPages}
          page={pageNumber + 1}
          onChange={(newPageNumber) => updateFilter({ pageNumber: newPageNumber - 1 })}
        />
      </Center>
      {count > 0 && (
        <Center>
          <ThemeText weight="lighter">{`${PAGE_SIZE * pageNumber + 1} - ${
            PAGE_SIZE * (pageNumber + 1) < count ? PAGE_SIZE * (pageNumber + 1) : count
          } von ${count} Kontakte`}</ThemeText>
        </Center>
      )}
    </div>
  );
};

const EmptyList = () => (
  <Stack>
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 50,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <Box
      sx={(theme) => ({
        width: '100%',
        height: 100,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        borderRadius: 10,
      })}
    />
    <ThemeText align="center">
      Die Kombination der ausgewählten <b>Filter</b> erzielt keine Ergebnisse.
    </ThemeText>
  </Stack>
);

export default ContactsTable;
